import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasNominaDispersionVinculacionItemComponent {
  constructor () {
    this.data = null
    this.faltante = null
    this.completado = null
  }

  $onInit () {
    let capturado = parseFloat(this.data.Pagos.reduce((prev, next) => prev + next.Importe, 0).toFixed(2))

    this.faltante = Math.abs(this.data.Total_Pagar - capturado)
    this.completado = capturado / this.data.Total_Pagar
  }
}

module.component('nominasNominaDispersionVinculacionItem', {
  controller: NominasNominaDispersionVinculacionItemComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/vinculacion/item/component.js